<jmkw-widget-control-bar
  [widgetParams]="widgetParams"
  [id]="id"
  (expand)="toggleExpanded($event)"
  (closeWidget)="closeWidget()"
  >
  @if (controlBarContent) {
    <ng-container
      right
      [ngTemplateOutlet]="controlBarContent!"
    ></ng-container>
  }
</jmkw-widget-control-bar>
@if (expanded) {
  <div
    class="projected-content-wrapper"
    [ngClass]="{ contracted: !expanded }"
    >
    <ng-container #widgetHost></ng-container>
  </div>
}
